import { Component, HostBinding, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
// import { getBrowserLang, TranslocoService } from '@ngneat/transloco';
import { AngularFaviconService } from 'angular-favicon';
import { KeycloakService } from 'keycloak-angular';
import { Tenant } from '@cloudia-shared/tenant/tenant.service';
import { BaseComponent } from '@tcp/cloudia-utilities';

@Component({
  selector: 'cloudia-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent extends BaseComponent implements OnInit {
  @HostBinding('class.theme-cloudia') public cloudiaTheme: boolean;
  tenant: string;

  constructor(
    private titleService: Title,
    private ngxFavicon: AngularFaviconService,
    private readonly kc: KeycloakService // private readonly transloco: TranslocoService
  ) {
    super();
  }

  ngOnInit() {
    this.tenant = this.tenantService.getTenant();
    this.enableThemes();
    this.titleService.setTitle(this.tenantConfig.title);
    this.ngxFavicon.setFavicon(this.tenantConfig.faviconUrl);
    // this.kc
    //   .getKeycloakInstance()
    //   .loadUserInfo()
    //   .then((x) => {
    //     const userProps = x as any;
    //     if (userProps.locale) {
    //       this.transloco.setActiveLang(userProps.locale);
    //     } else {
    //       this.transloco.setActiveLang(getBrowserLang());
    //     }
    //   })
    //   .catch(() => {
    //     this.transloco.setActiveLang(getBrowserLang());
    //   });
  }

  enableThemes() {
    this.cloudiaTheme =
      this.tenantService.getTenant() === Tenant['cloudia-customer'];
  }
}
